import { Link } from "react-router-dom";
import { APP_NAME, APP_LEGAL_NAME, APP_DOMAIN, SUPPORT_EMAIL } from "@/lib/branding";
import { BrandLogo } from "@/components/BrandLogo";

const COLUMNS = [
  {
    title: "Produit",
    links: [
      { label: "Fonctionnalités", href: "#modules" },
      { label: "Product Tour", href: "#tour" },
      { label: "Tarifs", href: "#tarifs" },
      { label: "FAQ", href: "#faq" },
      { label: "Nouveautés", href: "#" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Pour les DAF / CFO", href: "#personas" },
      { label: "Pour les TPE / PME", href: "#personas" },
      { label: "Pour les cabinets", href: "#personas" },
      { label: "Migration Pennylane", href: "#" },
      { label: "Migration Sage", href: "#" },
    ],
  },
  {
    title: "Ressources",
    links: [
      { label: "Centre d'aide", href: "#" },
      { label: "API & Développeurs", href: "#" },
      { label: "État du service", href: "#" },
      { label: "Blog CFO", href: "#" },
      { label: "Webinars", href: "#" },
    ],
  },
  {
    title: "Entreprise",
    links: [
      { label: "À propos", href: "#" },
      { label: "Carrières", href: "#" },
      { label: "Presse", href: "#" },
      { label: "Contact", href: `mailto:${SUPPORT_EMAIL}` },
      { label: "Politique de confidentialité", href: "#" },
    ],
  },
];

const BADGES = [
  "Factur-X ready 2026",
  "DSP2 Certifié",
  "RGPD compliant",
  "Hébergé en France · SecNumCloud",
];

export default function WelcomeFooter() {
  return (
    <footer className="bg-[#0F172A] text-slate-300" data-testid="welcome-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-10">
          {/* Brand column */}
          <div className="col-span-2">
            <BrandLogo variant="full" className="h-11" />
            <p className="mt-4 text-sm text-slate-400 max-w-xs leading-relaxed">
              La plateforme de gestion financière tout-en-un pour PME et cabinets
              d'expertise-comptable français.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {BADGES.map((b) => (
                <span
                  key={b}
                  className="text-[10px] font-semibold uppercase tracking-widest px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-slate-300"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500">
                {col.title}
              </div>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-slate-300 hover:text-white transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} {APP_LEGAL_NAME} · Tous droits réservés ·{" "}
            <span className="text-slate-400">{APP_DOMAIN}</span>
          </div>
          <div className="flex items-center gap-4">
            <Link
              to="/login"
              className="text-xs text-slate-400 hover:text-white transition-colors"
            >
              Se connecter
            </Link>
            <Link
              to="/register?plan=business"
              className="text-xs font-semibold text-white bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-md transition-colors"
            >
              Essayer gratuitement
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
